window.Vue = require("vue");
window.axios = require("axios");
window.throttle = require("lodash.throttle");
window.debounce = require("lodash.debounce");
// import * as Sentry from "@sentry/browser";
// import * as Integrations from "@sentry/integrations";

// import LogRocket from "logrocket";
require("./guest-ui");

window.environment = process.env.NODE_ENV;

if (process.env.NODE_ENV === "production") {
	// window.LogRocket = LogRocket;
	// LogRocket.init("owsnp2/rackbeat");
	// Sentry.init({
	// 	dsn: window.sentryApiKey,
	// 	integrations: [new Integrations.Vue({ Vue, attachProps: true })],
	// });
}

// window.Sentry = Sentry;

window.axios.defaults.headers.common["X-CSRF-TOKEN"] = window.csrfToken;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.parseBadResponse = function (error, newline = "<br/>") {
	let errorMessage = "";
	let responseData =
		error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
			? error.response.data
			: error.response || error;

	if (responseData.errors !== undefined && responseData.errors.message !== undefined) {
		errorMessage = responseData.errors.message;
	} else {
		for (let index in responseData.errors) {
			errorMessage += responseData.errors[index][0] + newline;
		}
	}

	return errorMessage;
};
